"use strict";

exports.__esModule = true;
exports["default"] = Company20;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Company20(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 40 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26 15.8v-.2c-.7-2.5-2.9-4.5-5.6-4.6h-.8c-2.7.2-4.9 2.1-5.6 4.6v.2c-.1.5.5 1.2 1.2 1.2h9.6c.6 0 1.3-.7 1.2-1.2M7 6c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3M14 13.3v-.2c-.4-1.5-2-3-3.7-3.2h-.4c-1.9.3-3.5 1.8-3.9 3.3v.2c0 .4.2 1.6 1.3 1.6h5.3c1.2 0 1.4-1.2 1.4-1.7M27 6c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3M34 13.3v-.2c-.4-1.5-2-3-3.7-3.2h-.4c-1.8.1-3.4 1.7-3.7 3.2v.2c0 .4.2 1.6 1.3 1.7h5.3c1 0 1.2-1.2 1.2-1.7M20 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 3.9 1.8 4 4c0 2.2-1.8 4-4 4z"
  }));
}